module.exports = __webpack_public_path__ + "static/media/Source of Electricity.0a68442b.mp4";